let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("5BMnr"), load("9QNjl")]).then(() => parcelRequire('8FuhP'));